import * as React from 'react';

import VerticalSpacing from 'components/vertical-spacing/VerticalSpacing';
import Tooltip from 'components/Tooltip';

import './admin-panel.scss';

type Props = {
  children?: React.ReactNode,
  title?: string,
  tooltip?: string
}

const AdminPanelBlockTitle = ({ children, title, tooltip }: Props) => (
  <React.Fragment>
    <div className="admin-panel__block-title">
      { title }
      {
        tooltip && (
          <Tooltip
            showQuestionMark
            message={tooltip}
            classNameWrapper="admin-panel__block-title-tooltip"
          />
        )
      }
      { children }
    </div>
    <VerticalSpacing type="small" />
  </React.Fragment>
);

export default AdminPanelBlockTitle;
